import { useEffect, useRef } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { handleCallback, setStoredSession } from '@/lib/pixelfed'
import { addStoredSession as addMastodonSession } from '@/lib/mastodon'
import { buildPixelfedAccount, buildMastodonAccount } from '@/lib/accountUtils'
import { detectPlatformFromNodeinfo } from '@/lib/nodeinfo'
import { PENDING_ACTIVE_ACCOUNT_KEY } from '@/constants/storage'
import { Center } from '@/components/Center'
import { Spinner } from '@/components/Spinner'
import { Text } from '@/components/Text'

export function PixelfedCallback() {
    const [searchParams] = useSearchParams()
    const navigate = useNavigate()
    const hasRun = useRef(false)

    useEffect(() => {
        if (hasRun.current) return
        hasRun.current = true

        const error = searchParams.get('error')
        if (error) {
            console.warn('Pixelfed OAuth error:', error, searchParams.get('error_description'))
            void navigate('/login?error=pixelfed_callback_failed')
            return
        }

        const code = searchParams.get('code')
        if (code) {
            handleCallback(code)
                .then(async session => {
                    // Detect the actual platform — user may have entered a Mastodon
                    // instance URL in the Pixelfed login form
                    const detected = await detectPlatformFromNodeinfo(session.instance_url)

                    let accountId: string
                    if (detected === 'mastodon') {
                        addMastodonSession(session)
                        accountId = buildMastodonAccount(session).id
                    } else {
                        setStoredSession(session)
                        accountId = buildPixelfedAccount(session).id
                    }

                    // Signal ProtocolContext to switch to this account after reload
                    localStorage.setItem(PENDING_ACTIVE_ACCOUNT_KEY, accountId)
                    window.location.href = '/'
                })
                .catch(err => {
                    console.error('Pixelfed callback error:', err)
                    void navigate('/login?error=pixelfed_callback_failed')
                })
        } else {
            void navigate('/login')
        }
    }, [searchParams, navigate])

    return (
        <Center className="min-h-screen bg-background">
            <div className="text-center">
                <Spinner size="lg" color="primary" className="mx-auto mb-4" />
                <Text variant="secondary">Completing sign in...</Text>
            </div>
        </Center>
    )
}
